import type { InferActionsType } from '~/Reducers';
import type { IClanStarsState } from '~/Reducers/ReducerClanStars';

export const CHANGE_TAB = 'CHANGE_TAB';
export const UPDATE_REWARDS = 'UPDATE_REWARDS';
export const UPDATE_STATE = 'UPDATE_STATE';

export type ActionsType = InferActionsType<typeof actionsClanStars>;

export const actionsClanStars = {
  changeTab: (tab: IClanStarsState['selectedTab']) =>
    ({
      type: CHANGE_TAB,
      payload: tab,
    }) as const,

  updateRewards: (data: IClanStarsState['accountRewards']) =>
    ({
      type: UPDATE_REWARDS,
      payload: data,
    }) as const,

  updateState: (data: {
    accountClanstars: IClanStarsState['accountClanstars'];
    accountRewards: IClanStarsState['accountRewards'];
    clanClanstarsCount: IClanStarsState['clanClanstarsCount'];
    rewardsInfo: IClanStarsState['rewardsInfo'];
  }) =>
    ({
      type: UPDATE_STATE,
      payload: data,
    }) as const,
};
